/**
 * Created by Daniela on 26/09/2016.
 */
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { newRoute, editRoute } from "../../shared/services/data.service";
import { GrupoMaterialListComponent } from "./grupo-material-list/grupo-material-list.component";
import { GrupoMaterialFormComponent } from "./grupo-material-form/grupo-material-form.component";
import { subgruposMateriaisRouter } from "./shared/data.service";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class GruposMateriaisRoutingModule {}

export  const gruposMateriaisRoutes: any[] = [
  {
    path: '',
    component: GrupoMaterialListComponent
  },{
    path: newRoute,
    component: GrupoMaterialFormComponent
  },{
    path: editRoute + '/:id',
    component: GrupoMaterialFormComponent
  },{
    path: subgruposMateriaisRouter + '/' + editRoute + '/:grupoId/:id',
    component: GrupoMaterialFormComponent
  },{
    path: subgruposMateriaisRouter + '/' + newRoute + '/:grupoId',
    component: GrupoMaterialFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/grupos-materiais/grupos-materiais.routing.ts
 **/